// src/services/quotationApi.js
import api from "./apiBase";

/**
 * Monta um FormData no formato esperado pelo backend.
 * @param {{ description: string, contactEmail?: string, files?: File[] }} payload
 */
function createQuotationFormData({
  description,
  contactEmail,
  contactWhats,
  files = [],
}) {
  const fd = new FormData();
  fd.set("description", description);
  if (contactEmail) fd.set("contactEmail", contactEmail);
  if (contactWhats) fd.set("contactWhats", contactWhats);
  for (const f of files) {
    if (f) fd.append("files", f, f.name);
  }
  return fd;
}

/**
 * Envia a solicitação de cotação (sempre multipart/form-data).
 * Espera receber um FormData (use createQuotationFormData).
 */
function submitQuotationRequest(formData) {
  return api.post("/quotations", formData);
}

export { createQuotationFormData, submitQuotationRequest };
